import { useQuery } from 'react-query';

import {
  FetchCustomerPaymentMethodListResponse,
  PAYMENT_METHOD_LIST_KEY,
  fetchCustomerPaymentMethodList,
} from '@utils/backend-api/stripe';

export default function usePaymentMethodList() {
  const { data: paymentMethodList, isLoading: isLoadingPaymentMethodList } =
    useQuery<FetchCustomerPaymentMethodListResponse>(
      PAYMENT_METHOD_LIST_KEY,
      async () => await fetchCustomerPaymentMethodList()
    );
  return { ...paymentMethodList, isLoadingPaymentMethodList };
}
